<template>
  <div v-if="livingOption && subsection && property" class="live-property">    
    <main-content
      right-sidebar="true"
    >
      <image-gallery 
        :autoplay="false" 
        :contain-images="false"
        :images="images" 
        :show-nav="true"
      />

      <div v-if="this.propertyImage" class="live-property__lot-image">
        <img :src="$store.state.assetsPath + this.propertyImage" alt="">
      </div>
      <!-- <div class="live-property__details-pane">
        <ul>
          <li>label: {{ property.label }}</li>
          <li>area m^2: {{ property.msq }}</li>
          <li>value: {{ property.price }}</li>
          <li>status: {{ property.status }}</li>
          <li>view: {{ property.view }}</li>
        </ul>
        <div class="live-property__models">
          <ul
            v-for="model in property.models"
            class="live-property__model"
            :key="model._id"
          >
            <li>{{ model.label }}</li>
            <li>{{ model.type }}</li> 
            <li>{{ model.beds }}</li>
            <li>images:
              <ul>
                <li v-for="path in model.images" :key="path">{{ path }}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div> -->
    </main-content>
    <right-sidebar
      :logo="$store.state.config.sidebarLogo"
      :minimap="livingOption.sidebarMinimap"
      :heading="`${livingOption.label} – ${propertyNumber}`"
    >
      <div class="description" slot="description">
        <div v-if="propertyType == 'house'" class="property__subsection">
          {{ property.design }} – {{ property.builder }}
        </div>
        <div v-if="propertyType == 'apartment'" class="property__subsection">
          {{ subsection.displayName }}
        </div>
        <div v-if="property.models[0].features !== ''" class="property__label">
          Features
        </div>
        <div class="property__feature-list">
          <span v-html="property.models[0].features"></span>
        </div>

        <div class="property__bottom-wrapper">

          <div class="property__label">
            Price
          </div>
          <div v-if="propertyType == 'apartment'" class="property__price">
            ${{ priceFormatted }}
          </div> 
          <div v-if="propertyType == 'house'" class="property__price">
            ${{ totalPackagePriceFormatted }}
          </div>        
          <div class="property__label">
            {{ propertyType == 'house' ? 'House' : 'Living' }}
          </div>
          <div v-if="propertyType == 'house'" class="property__size">
            {{ property.building_area_msq ? property.building_area_msq : '-' }}<span>M<sup>2</sup></span>
          </div>
          <div v-else-if="propertyType == 'apartment'" class="property__size">
            {{ property.living_msq ? property.living_msq : '-' }}<span>M<sup>2</sup></span>
          </div>
          <div v-else class="property__size">
            <span>- M<sup>2</sup></span>
          </div>
          <div class="property__label">
            {{ propertyType == 'house' ? 'Land' : 'Outdoor' }}
          </div>
          <div v-if="propertyType == 'house'" class="property__size">
            {{ property.landarea_msq ? property.landarea_msq : '-' }}<span>M<sup>2</sup></span>
          </div>
          <div v-if="propertyType == 'apartment'" class="property__size">
            {{ property.outdoor_msq ? property.outdoor_msq : property.models[0].outdoor_msq }}<span>M<sup>2</sup></span>
          </div>
          <div class="property__feature">
            <div class="feature">
              <div class="feature__title">Beds</div>
              <div class="feature__circle">
                <div class="feature__value">{{ property.models[0].beds ? property.models[0].beds : '-' }}</div>
              </div>
            </div>
            <div class="feature">
              <div class="feature__title">Bath</div>
              <div class="feature__circle">
                <div class="feature__value">{{ property.models[0].baths ? property.models[0].baths : '-' }}</div>
              </div>
            </div>
            <div class="feature">
              <div class="feature__title">Car</div>
              <div class="feature__circle">
                <div class="feature__value">{{ property.models[0].cars ? property.models[0].cars : '-' }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <template slot="bottom-slot">
        <router-link tag="button" class="right-sidebar__back" :to="`/live/${livingOption._id}/subsection/${subsection._id}`"><fa icon="chevron-left"/>Back</router-link>
        <div class="right-sidebar__search"></div>
        <!-- <button class="right-sidebar__search"><fa icon="search"/>Search</button> -->
      </template>
    </right-sidebar>
  </div>  
</template>
<script>
// A subsection either links to properties or other subsections 
import ImageGallery from '@/components/ImageGallery'
import MainContent from '@/components/MainContent'
import RightSidebar from '@/components/RightSidebar'
import { mapGetters } from 'vuex'
export default {
  components: { ImageGallery, MainContent, RightSidebar },

  computed: {
    ...mapGetters({
      livingOption: 'property/activeLivingOption',
      property: 'property/activeProperty',
      subsection: 'property/activeSubsection'
    }),

    priceFormatted () {
      // Takes price and adds ',' every thousand
      if (this.property.price === null) {
        return '-';
      }
      let remaining = this.property.price.toString() // this string gets smaller as we loop over its length taking '000 off each loop
      let formatted = '' // this is the string that we add the formatted '000s to
      while (remaining.length > 3) { // 3 because '000 (thousand)
        formatted = ',' + remaining.substring(remaining.length - 3, remaining.length) + formatted // , + <last 3 digets> + <any already formatted digets> 
        remaining = remaining.substring(0, remaining.length - 3) // remove the last 3 digets from remaining
      }
      formatted = remaining + formatted // < 3 digets left so no more ',' to add
      return formatted
    },

    totalPackagePriceFormatted () {
      // Takes price and adds ',' every thousand
      if (this.property.total_package_price === null) {
        return '-';
      }
      let remaining = this.property.total_package_price.toString() // this string gets smaller as we loop over its length taking '000 off each loop
      let formatted = '' // this is the string that we add the formatted '000s to
      while (remaining.length > 3) { // 3 because '000 (thousand)
        formatted = ',' + remaining.substring(remaining.length - 3, remaining.length) + formatted // , + <last 3 digets> + <any already formatted digets> 
        remaining = remaining.substring(0, remaining.length - 3) // remove the last 3 digets from remaining
      }
      formatted = remaining + formatted // < 3 digets left so no more ',' to add
      return formatted
    },

    details () {
      return `
        
      `
    },

    images () {
      let images = []
      images.push(...this.property.models[0].images)
      return images
    },

    propertyImage () {
      return this.property.images[0]
    },

    propertyNumber () {
      return this.property.label.substring(this.property.label.indexOf(' ') + 1)
    },

    propertyType () {
      let propertyType = this.livingOption.propertyTypes[0].toLowerCase()
      const type = propertyType === 'terrace' ? 'house' : propertyType
      return type
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
.live-property {
  .description {
    // align-content: flex-start;
    color: $right-desc-color;
    display: flex;
    flex-direction: column;
    // justify-content: flex-start;
  }

  &__lot-image {
    display: none;
    height: calc(9rem * 2.5);
    position: absolute;
    right: 2rem;
    top: 2rem;
    width: calc(16rem * 2.5);

    img {
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  .property {
    &__subsection {
      font-size: 1.9rem;
      text-transform: uppercase;
      margin-top: -1.5rem;
      opacity: 0.7;
    }
    &__label {
      // color: $lblue;
      font-size: 1.5rem;
      text-transform: uppercase;
      margin-top: 1.5rem;
      opacity: 0.7;

      &--lower {
        margin-bottom: 1rem;
        text-transform: capitalize;
      }
    }

    &__icon {
      font-size: 3rem;
      margin-top: 1rem;
      span {
        font-size: 2.7rem;
        margin-right: 1rem;
      }
    }

    &__price, &__size {
      font-size: 3rem;
      font-weight: 600;
      letter-spacing: .075em;

      span {
        font-size: 2rem;
        // opacity: 0.8;
        margin-left: 0.3rem;
      }
    }

    &__feature-list {
      font-size: 1.4rem;
      letter-spacing: .1em;
      line-height: 1.3;
      flex-grow: 1;
      font-weight: 200;
      overflow: hidden;

      p:first-of-type {
        margin-top: .3rem;
      }

      ul {
        margin-top: .3rem;
        padding-left: 1em;
      }
      li {
        margin-bottom: .3rem;
      }
    }

    &__bottom-wrapper {
      background: $white;
      bottom: 6.5rem;
      position: absolute;
      width: 100%;
    }

    &__feature {
      display: flex;
      margin-top: 1.5rem;

      .feature {
        display: flex;
        flex-direction: column;
        margin-right: 2em;

        &__title {
          font-size: 1.5rem;
          // font-weight: 200;
          // letter-spacing: .3rem;
          margin: 0 auto;
          opacity: 0.7;
          text-transform: uppercase;
        }

        &__circle {
          background: #fff;
          border-radius: 50rem;
          height: 4.6rem;
          margin: .5em auto 0;
          min-width: 4.6rem;
          position: relative;
          width: 100%;
        }

        &__value {
          font-size: 2rem;
          left: 50%;
          padding: 0 1.5rem;
          position: relative;
          top: 50%;
          text-align: center;
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  .main-content {
    background-color: #fff;
  }
  
  &__details-pane {
    position: absolute;
    z-index: 9;
    color: black;
    font-size: 3rem;
  }

  &__models {
    display: flex;
    flex-wrap: wrap;
  }

  &__model {

  }
}
</style>